import { render, staticRenderFns } from "./WarehouseScreenWriteOff.vue?vue&type=template&id=bb5b6380"
import script from "./WarehouseScreenWriteOff.vue?vue&type=script&lang=js"
export * from "./WarehouseScreenWriteOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports